import React from "react";
import { Link } from "react-router-dom";
import "./SService.css";

function SService(props) {
  return (
    <div className="col-md-6 col-lg-4 col-sm-6 col-12">
      <div className="short-service">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <div className="content" onClick={props.ToggleModal}>
          <Link>
            <img src={props.service.image} alt="" />
          </Link>
          <Link>
            {" "}
            <h2>{props.service.title} </h2>
          </Link>
          <Link>
            {" "}
            <p>{props.service.description.slice(0,100)}... </p>
          </Link>
          <button className="text-center" onClick={props.ToggleModal}>
            Learn more
          </button>
        </div>
      </div>
    </div>
  );
}

export default SService;
